define('app/utilities/urlKey',['../ui/dialog', 'underscore', 'jquery-ui'], function (dialog, _) {
    return function () {
        var self = this;
        self.url = window.location.toString();
        self.queryValues = [];

        function getUrlParameters() {
            var query = window.location.hash.substring(1);
            if (!query) return '';

            var queryComponents = query.split('||');
            var queryPairs = [];
            _.each(queryComponents, function (c) {
                var elements = c.split('|');
                // Make sure to only add this if the key has some value.
                if (elements[0].length > 0) {
                    queryPairs.push({
                        key: elements[0],
                        value: elements.length === 2 ? elements[1] : ''
                    });
                }
            });

            self.url = window.location.toString();
            self.queryValues = queryPairs;
        }

        // Gets a value from the query string.
        self.Get = function (key) {
            var url = window.location;
            if (url !== self.url) getUrlParameters();

            var queryItem = _.find(self.queryValues, function (qv) {
                return qv.key === key;
            });

            if (queryItem) return queryItem.value;
            return undefined;
        };

        // Sets a value into the query string
        self.Set = function (key, value) {
            var url = window.location.toString();
            if (url !== self.url) getUrlParameters();
            var queryItem = _.find(self.queryValues, function (qv) {
                return qv.key === key;
            });

            if (queryItem) queryItem.value = value;
            else {
                queryItem = { key: key, value: value };
                self.queryValues.push(queryItem);
            }

            var queryString = '';
            _.each(self.queryValues, function (qv) {
                queryString += qv.key + '|' + qv.value + '||';
            });

            var currentUrl = self.url.split('#')[0];
            var newUrl = currentUrl + '#' + queryString;

            // Internet Explorer has a maximum URL length of 2048 characters, so if an IE user
            // builds up a really big query string we need to try and handle it.
            // Since it is a business priority that users be able to bookmark the page
            // and come back to it, preset options and all, there isn't a huge
            // amount that we can do to get around this.
            if (navigator && navigator.appName.search(/internet explorer/i) > -1 && newUrl.length >= 2048) {
                dialog.show('Maximum items',
                            $('<div />').append('<p>Your web browser won\'t let you add more. Please try removing some items and try again.</p>'),
                            {
                                modal: true,
                                resizable: false
                            });
                return;
            }

            window.location = newUrl;
        };

        // When constructed, get the current URL parameters.
        getUrlParameters();
        window.loadedModules('URL Key');
    }
});
